package com.fireavert.yardi.service_requests.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class YardiServiceRequestCreateEditResponse(
    val response: String
)
